// Frittstående PERSTAT/sanitet-panel (poppet ut). Egen WS-feed; tap-meldinger
// flyter via hubbens collab-fanout (org-scope) og flettes monotont.
import { parseCasualtyOne, mergeCasualty, type Casualty } from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { CasualtyPanel } from '../ui/casualty.js';
import { byggKontekst } from '../kontekst.js';

export function mountCasualtyPanel(root: HTMLElement, feed: Feed, sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const cs = new Map<string, Casualty>();
  const upsert = (c: Casualty) => {
    const e = cs.get(c.id); cs.set(c.id, e ? mergeCasualty(e, c) : c);
    if (cs.size > 2000) { const o = [...cs.values()].sort((a, b) => a.tsMs - b.tsMs)[0]; if (o) cs.delete(o.id); }
  };
  const panel = new CasualtyPanel({
    self: user.id,
    getCasualties: () => [...cs.values()],
    publish: (c) => { upsert(c); feed.send?.({ type: 'casualty', casualty: c }); },
    focus: (c) => { if (c.lat !== undefined && c.lon !== undefined) sync.post({ type: 'focus', lon: c.lon, lat: c.lat, label: c.callsign }); },
    // ⚠ Dette vinduet har INGEN kart, altså ingen kartsenter og ingen GPS.
    // Posisjonen er derfor ÆRLIG ukjent (`posisjon: null`) — feltet står tomt og
    // merkes «ukjent», i stedet for å arve et koordinat vi ikke har.
    kontekst: () => byggKontekst({ bruker: user, posisjon: null, naaMs: Date.now() }),
    naa: () => Date.now(),
  });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
  feed.onCollab?.((m) => { if (m.kind === 'casualty' && m.casualty) { const c = parseCasualtyOne(m.casualty); if (c) { upsert(c); panel.render(); } } });
  feed.start();
}
